import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { notificationSlice } from './containers/Notifications/slice';
import { portalSlice } from './layouts/MainLayout/slice';
import { loginSlice } from './containers/login/slice';
import { projectsSlice } from './containers/projects/slice';
import { languagesSlice } from './containers/languages/slice';
import { workspaceSlice } from './containers/projectWorkspace/slice';
import { rootSaga } from './root-saga';

export const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: {
    [notificationSlice.name]: notificationSlice.reducer,
    [portalSlice.name]: portalSlice.reducer,
    [loginSlice.name]: loginSlice.reducer,
    [projectsSlice.name]: projectsSlice.reducer,
    [languagesSlice.name]: languagesSlice.reducer,
    [workspaceSlice.name]: workspaceSlice.reducer,
  },
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;

export default store;
